module.exports = __webpack_public_path__ + "static/media/vf_wskirt_core.0e2839b1.svg";